import { apiUrl } from './../constantsSMB/apiUrl';
import api from '../serviceSMB/apiService';
import { Utils } from '../utilSMB/utils';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../serviceSMB/logService';
// import { errorAction } from './errorAction'
import { getVZDLInit } from './../serviceSMB/vzdl';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getProductsFromJSON = (dispatch) => {
  var response = require('../containers/product/sampleProductsJson.json');
  dispatch({ type: 'PRODUCTSFROMJSON', value: response });
  dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
  return response;
};

export const getProductsFromApi = (request, dispatch, visitId) => {
  try {
    var selectedResponse;
    let paginationData;
    let selectedProdDescData;
    var proddata = window.prodrespSMB;
    logOtherInfo(detailsInfo('ProductsPage', visitId, 'getProductsFromApi', 'Inside getProductsFromApi'));
    const categoriesUrl = apiUrl().productsUrl;
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    if (proddata !== undefined && proddata !== '' && proddata !== null) {
      var response = proddata;
      // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: 'RESET_LOADER' } });
      paginationData = {
        pagination: response.pagination,
        totalPageCount: response.totalPageCount,
        productCount: response.productCount,
        minProdCount: response.minProdCount,
        maxProdCount: response.maxProdCount,
        zeroProductsMessage: response.zeroProductsMessage,
      };
      selectedProdDescData = { groupName: response.groupName, groupDesc: response.groupDescription, footerDescription: response.footerDescription };
      selectedResponse = response.products.map((object, index) => {
        return { ...object, selectedProd: object.items[0], groupId: 'G' + index, modifiedName: Utils.removeSpecialChars(object.name) };
      });
      dispatch({ type: 'PRODUCTSFROMAPI', value: selectedResponse });
      dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
      dispatch({ type: 'PAGINATION', value: paginationData });
      dispatch({ type: 'SELECTEDCATEGORYDESC', value: selectedProdDescData });
      dispatch({ type: 'PRODUCTBANNER', value: response.prodBanner });
      window.prodrespSMB = '';
    } else {
      api(categoriesUrl, 'POST', request)
        .then((response) => {
          window.scrollTo(0, 0);
          if (Utils.isNotNull(response)) {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: 'RESET_LOADER' } });
            paginationData = {
              pagination: response.pagination,
              totalPageCount: response.totalPageCount,
              productCount: response.productCount,
              minProdCount: response.minProdCount,
              maxProdCount: response.maxProdCount,
              zeroProductsMessage: response.zeroProductsMessage,
            };
            selectedProdDescData = {
              groupName: response.groupName,
              groupDesc: response.groupDescription,
              footerDescription: response.footerDescription,
            };
            selectedResponse = response.products.map((object, index) => {
              return { ...object, selectedProd: object.items[0], groupId: 'G' + index, modifiedName: Utils.removeSpecialChars(object.name) };
            });
            dispatch({ type: 'PRODUCTSFROMAPI', value: selectedResponse });
            dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
            dispatch({ type: 'PAGINATION', value: paginationData });
            dispatch({ type: 'SELECTEDCATEGORYDESC', value: selectedProdDescData });
            dispatch({ type: 'PRODUCTBANNER', value: response.prodBanner });
          } else {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: 'RESET_LOADER' } });
          }
        })
        .catch((error) => {
          let errorMsg = `MethodName:getProductsFromApi,errorMessage:${error.message}`;
          logKafka('ERROR', 'ProductsPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
          // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: 'RESET_LOADER' } });
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
        });
    }
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'getProductsFromApi', ex);
  }
};

export const addToCart = (request, dispatch) => {
  var response = require('../containers/Cart/sampleCartProductDetailsJson.json');
  dispatch({
    type: 'CARTPRODUCTSDETAILSFROMJSON',
    value: response.data.prodAccessoryList,
    subTotal: response.data.Subtotal,
    total: response.data.Total,
    shippingcrg: response.data.Shippingcharge,
    tax: response.data.Tax,
  });
  return request;
};

export const updateCart = (request, visitId, dispatch) => {
  try {
    logOtherInfo(detailsInfo('ProductsPage', visitId, 'updateCart', 'Inside updateCart'));
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: 'Updating your cart' } });
    const categoriesUrl = apiUrl().updateCart + '/' + visitId;
    return new Promise((resolve, reject) => {
      api(categoriesUrl, 'POST', request)
        .then((response) => {
          dispatch({
            type: 'CARTPRODUCTSDETAILSFROMJSON',
            value: response.data.prodAccessoryList,
            subTotal: response.data.subTotal,
            total: response.data.total,
            shippingcrg: response.data.shippingCharge,
            tax: response.data.tax,
          });
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
          resolve(response);
        })
        .catch((error) => {
          let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
          logKafka('ERROR', 'ProductsPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
        });
    });
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'updateCart', ex);
  }
};

export const getPageinfoByName = (request, dispatch, visitId) => {
  try {
    var bannerData = window.bannerrespSMB;
    logOtherInfo(detailsInfo('ProductsPage', visitId, 'getPageinfoByName', 'Inside getPageinfoByName'));
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    const bannerUrl = apiUrl().bannerUrl;
    if (
      bannerData !== undefined &&
      bannerData !== '' &&
      bannerData !== null &&
      bannerData.categoryId !== undefined &&
      bannerData.categoryId !== null &&
      bannerData.categoryId !== ''
    ) {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
      bannerStatus(true, dispatch);
      dispatch({ type: 'PAGEINFO', value: bannerData });
      window.bannerrespSMB = '';
    } else {
      return new Promise((resolve, reject) => {
        api(bannerUrl, 'POST', request)
          .then((response) => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (Utils.isNotNull(response) && response.categoryId !== undefined && response.categoryId !== null && response.categoryId !== '') {
              bannerStatus(true, dispatch); /** setting banner call status which used in wrapper product to render error page */
              dispatch({ type: 'PAGEINFO', value: response });
              // let request = {
              //   "categoryId": response.categoryId,
              //   "productId": response.productId
              // }
              // dispatch({ type: 'STOREPRODUCTID', value: request });
              resolve(response);
            } else {
              bannerStatus(false, dispatch);
              dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

              /**will render 404 content if banner returns null */
              // errorAction("404", "Product", "Product", "applogs", visitId, dispatch, true, "ProductsFetchFailed");
            }
          })
          .catch((error) => {
            let errorMsg = `MethodName:getPageinfoByName,errorMessage:${error.message}`;
            logKafka('ERROR', 'ProductsPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            getVZDLInit(visitId, '', '', '', '', '', '', error.message);
          });
      });
    }
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'getPageinfoByName', ex);
  }
};
export const bannerStatus = (request, dispatch) => {
  dispatch({ type: 'BANNERSTATUS', value: request });
};
export const productValue = (request, dispatch) => {
  dispatch({ type: 'PRODUCTSFROMAPI', value: request });
};
export const emptyPageinfo = (dispatch) => {
  dispatch({ type: 'PAGEINFO', value: '' });
};
export const setSelectedProduct = (selectedProd, dispatch) => {
  dispatch({ type: 'SELECTEDPROD', value: selectedProd });
};
export const setFilterData = (dispatch, request) => {
  dispatch({ type: 'SETFILTERDATA', value: request });
};
export const clearFilterData = (dispatch, request) => {
  dispatch({ type: 'CLEARFILTERDATA', value: request });
};
export const onClear = (dispatch) => {
  dispatch({ type: 'DESTROY_SESSION' });
};
